export default __webpack_public_path__ + "static/homeHumanCard-ead8e236f785c7378c59525d13614b7f.png";